import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import {
  SpacingRow,
  SpacingRowAlign,
  SpacingUnit,
  StatusMark,
} from 'components/ui';
import { FormListEntity } from 'entities/FormList';
import { FormStatus, STATUS_MAPPER } from 'entities/common';

type StatusColumnProps = {
  entity: FormListEntity;
};

const STATUS_TRANSLATION_KEYS: Record<FormStatus, string> = {
  [FormStatus.DRAFT]: 'formStatus.draft',
  [FormStatus.FILE_UPLOAD]: 'formStatus.draft',
  [FormStatus.VALIDATION]: 'formStatus.draft',
  [FormStatus.PUBLISHED]: 'formStatus.published',
  [FormStatus.FINISHED]: 'formStatus.finished',
};

const StatusColumn: React.FC<StatusColumnProps> = ({ entity }) => {
  const { t } = useTranslation();
  const result = STATUS_MAPPER[entity.status];
  const translationKey = STATUS_TRANSLATION_KEYS[entity.status];

  return (
    <SpacingRow hSpacing={SpacingUnit.unit2} align={SpacingRowAlign.center}>
      <StatusMark colorToken={result?.colorToken} />
      <Typography.Text>{t(translationKey)}</Typography.Text>
    </SpacingRow>
  );
};

export default observer(StatusColumn);
